// services/ProformaService.js
import http from "./AxiosInstance";

class ProformaService {
  // Créer un nouveau proforma
  createProforma(data) {
    return http.post("/proforma/create", data);
  }

  // Récupérer tous les proformas avec pagination et filtres
  getAllProformas(params = {}) {
    return http.get("/proforma/all", { params });
  }

  // Récupérer un proforma par ID
  getProformaById(id) {
    return http.get(`/proforma/${id}`);
  }

  // Mettre à jour un proforma
  updateProforma(id, data) {
    return http.put(`/proforma/update/${id}`, data);
  }

  // Changer le statut d'un proforma
  updateProformaStatus(id, data) {
    return http.put(`/proforma/status/${id}`, data);
  }

  // Convertir un proforma en facture
  convertToFacture(id, data) {
    return http.post(`/proforma/convert/${id}`, data);
  }

  // Annuler/supprimer un proforma
  deleteProforma(id, data) {
    return http.delete(`/proforma/delete/${id}`, { data });
  }

  // Récupérer les statistiques des proformas
  getProformaStats(periode) {
    return http.get(`/proforma/statistiques/${periode}`);
  }

  // Récupérer les proformas par statut
  getProformasByStatus(status) {
    return http.get(`/proforma/status/${status}/list`);
  }

  // Rechercher des proformas par nom de client
  searchProformasByClient(nomClient) {
    return http.get(`/proforma/search/client`, {
      params: { nom: nomClient }
    });
  }

  // Récupérer les proformas récents
  getRecentProformas(limit = 10) {
    return http.get("/proforma/recent", {
      params: { limit }
    });
  }

  // Dupliquer un proforma existant
  duplicateProforma(id, data) {
    return http.post(`/proforma/duplicate/${id}`, data);
  }

  // Envoyer le proforma par email
  sendProformaByEmail(id, data) {
    return http.post(`/proforma/send-email/${id}`, data);
  }
}

const proformaService = new ProformaService();
export default proformaService;